import React, { FC } from "react";
import { Button, Result } from "antd";
import { useIntl } from "react-intl";
import { useRouter } from "next/router";

export const QuestionNotFound: FC = () => {
  const { formatMessage } = useIntl();

  const router = useRouter();

  return (
    <Result
      status="error"
      title={formatMessage({ id: "survey.error" })}
      subTitle={formatMessage({ id: "survey.error.description" })}
      extra={[
        <Button type="primary" key="console" onClick={() => router.push("/")}>
          {formatMessage({ id: "home" })}
        </Button>,
      ]}
    />
  );
};
